import { html } from 'lit-html';
import { RrAreaFromExternalSite } from '../../../core/views/pc/rr_item/rr_area_from_external_site';
import { RrAreaNormal } from '../../../core/views/pc/rr_item/rr_area_normal';
import { RrAreaModal } from '../../../core/views/pc/rr_item/rr_area_modal';
import { ItemJsEnv } from '../../models/item_js_env';

export const RrBodyItemExternalSite = (model: ItemJsEnv) => html`
${RrAreaFromExternalSite(model.rrAreaProfileItemExternalSite, model.isLogin)}
`;

export const RrBodyItemNormalUpper = (model: ItemJsEnv) => html`
${RrAreaNormal(model.rrAreaProfileItemNormalUpper, model.isLogin)}
`;

export const RrBodyItemNormalLower = (model: ItemJsEnv) => html`
${RrAreaNormal(model.rrAreaProfileItemNormalLower, model.isLogin)}
`;

export const RrBodyItemModal = (model: ItemJsEnv) => html`
${RrAreaModal(model.rrAreaProfileItemModal, model.isLogin, true)}
`;
